import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  grid: {
    paddingBottom: theme.spacing(6),
  },
}));
